import React from "react";
import { Modal } from "antd";

const IndexModal = ({
  open,
  onClose,
  title,
  width = 550,
  children,
  modalContainerClass,
  useCustomClass,
  maxContentHeight = "80vh",
  closable= "true"
}) => {

  const modalClassName = [
    useCustomClass ? "custom-ant-modal-content" : "",
    typeof width === "string" ? width : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={width}
      centered
      destroyOnClose
      title={title ? <h2 className="popup-modal-title">{title}</h2> : null}
      className={modalClassName}
      closable={closable}
    >
      <div 
        className={`overflow-y-auto rounded-md ${modalContainerClass}`}
        style={{ maxHeight: maxContentHeight }}
      >
        {children}
                   
      </div>

    </Modal>
  );
};

export default IndexModal;
